import React, { useMemo } from 'react';
import DataTable, {
	DataTableColumn,
} from '../../../Base/Components/DataTable/DataTable';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { useWorkplaceSubscriptionMembershipsQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import { printInvoice } from '../../../Invoice/Services/InvoicePrint.service';

interface Props {
	workplaceId: string;
}

interface ORSMSubscriptionPayment {
	id: string;
	createdAt: string;
	invoiceNumber: string;
	price: string;
	invoiceUrl: string;
}

const ORSMSubscriptionPaymentsColumns: DataTableColumn<
	ORSMSubscriptionPayment,
	unknown
>[] = [
	{
		key: 'date',
		label: 'component.ORSMSubscriptionPayments.createdAt',
		renderItem: (item: ORSMSubscriptionPayment) => (
			<FormattedMomentDate date={item.createdAt} format={DateFormat.DATE} />
		),
	},
	{
		key: 'invoiceNumber',
		label: 'component.ORSMSubscriptionPayments.invoiceNumber',
		renderItem: (item: ORSMSubscriptionPayment) => item.invoiceNumber,
	},
	{
		key: 'price',
		label: 'component.ORSMSubscriptionPayments.price',
		renderItem: (item: ORSMSubscriptionPayment) => item.price,
	},
	{
		key: 'invoiceDownload',
		label: 'component.ORSMSubscriptionPayments.invoice',
		renderItem: (item: ORSMSubscriptionPayment) => (
			<LinkButton
				title='component.ORSMSubscriptionPayments.printInvoice'
				theme={Theme.BLUE}
				onClick={() => printInvoice({ url: item.invoiceUrl })}
			/>
		),
	},
];

const ORSMSubscriptionPayments: React.FC<Props> = ({ workplaceId }) => {
	const { data, isLoading } = useWorkplaceSubscriptionMembershipsQuery({
		where: {
			code: 'osmr_workplace_subscription',
			workplaceId,
		},
	});

	const tableData: ORSMSubscriptionPayment[] = useMemo(() => {
		const temp: ORSMSubscriptionPayment[] = [];

		data?.workplaceSubscriptionMemberships?.forEach(memberShip => {
			const order = memberShip.order;
			if (order) {
				order.invoices?.forEach(invoice => {
					temp.push({
						id: order.id!,
						createdAt: order.issueDate,
						invoiceNumber: invoice.number!,
						price: order.totalPrice!.formattedPrice!,
						invoiceUrl: invoice.url!,
					});
				});
			}
		});

		return temp;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<DataTable<ORSMSubscriptionPayment, unknown>
			columns={ORSMSubscriptionPaymentsColumns}
			table={{}}
			data={tableData}
			rowStyle={{ border: 0 }}
		/>
	);
};

export default ORSMSubscriptionPayments;
